<script>
  import { isAllTooManyPeople } from './../store/fetchAvailabilityEnableDates.js';

  export let Status;

  $: isAvailable = Status === 'A';
  $: isNotAvailable = Status === 'B' || Status !== 'M';
</script>

{#if isAvailable && !$isAllTooManyPeople}
  <span
    class="d-flex f5 poppins-bold-font mb-2 ml-auto text-green"
    data-testid="availability-item-status"
    ><svg
      class="d-inline mr-1"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 22"
      width="16"
      height="16"
      aria-hidden="true"
      focusable="false"
      ><path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11S17.075 0 11 0z"
        fill="currentColor" /><path
        d="M16.28 8.28a.75.75 0 00-1.06-1.06l-5.97 5.97-2.47-2.47a.75.75 0 00-1.06 1.06l3 3a.75.75 0 001.06 0l6.5-6.5z"
        fill="#fff" /></svg
    >Available</span>
{:else if isNotAvailable}
  <span
    class="d-flex f5 poppins-bold-font mb-2 ml-auto text-red"
    data-testid="availability-item-status">
    <svg
      class="d-inline mr-1"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 22"
      width="16"
      height="16"
      aria-hidden="true"
      focusable="false"
      ><path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11S17.075 0 11 0z"
        fill="currentColor" /><path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 11a1 1 0 011-1h9.481a1 1 0 110 2H6a1 1 0 01-1-1z"
        fill="#fff" /></svg
    >Not available</span
  >{/if}
